// extracted by mini-css-extract-plugin
module.exports = {"navigations":"DrawerContent-module--navigations--2-rEL","link":"DrawerContent-module--link--2gPye","listItem":"DrawerContent-module--listItem--2BmOU"};